import { render } from "./ClientesConColecciones.vue?vue&type=template&id=52acdf3f&scoped=true"
import script from "./ClientesConColecciones.vue?vue&type=script&lang=ts"
export * from "./ClientesConColecciones.vue?vue&type=script&lang=ts"

import "./ClientesConColecciones.vue?vue&type=style&index=0&id=52acdf3f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52acdf3f"

export default script